import Box from '@mui/material/Box';

export default function ReportPageBreak() {
  return (
    <Box component="div" sx={{ display: "block", pageBreakBefore: "always", pageBreakInside: "avoid" }}></Box>
  );
}
